import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Locations from './pages/Locations';
import BookNow from './pages/BookNow';
import Store from './pages/Store';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import { Toaster } from './components/ui/sonner';

import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './admin/context/AuthContext';
import { ProtectedRoute } from './admin/components/ProtectedRoute';
import AdminLayout from './admin/components/AdminLayout';
import AdminLogin from './admin/pages/AdminLogin';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminBookings from './admin/pages/AdminBookings';
import AdminCreateBooking from './admin/pages/AdminCreateBooking';
import AdminCreateRentalBooking from './admin/pages/AdminCreateRentalBooking';
import AdminEditBooking from './admin/pages/AdminEditBooking';
import AdminCalendar from './admin/pages/AdminCalendar';
import AdminUsers from './admin/pages/AdminUsers';
import AdminFacilities from './admin/pages/AdminFacilities';
import AdminRefunds from './admin/pages/AdminRefunds';

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <Routes>
            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/book" element={<BookNow />} />
              <Route path="/store" element={<Store />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            {/* Admin — login is public */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Admin — protected */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="bookings" element={<AdminBookings />} />
              <Route path="bookings/new" element={<AdminCreateBooking />} />
              <Route path="bookings/rentals/new" element={<AdminCreateRentalBooking />} />
              <Route path="bookings/:id/edit" element={<AdminEditBooking />} />
              <Route path="calendar" element={<AdminCalendar />} />
              <Route path="refunds" element={<AdminRefunds />} />
              <Route
                path="users"
                element={
                  <ProtectedRoute requireOwner>
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="facilities"
                element={
                  <ProtectedRoute requireOwner>
                    <AdminFacilities />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
          <Toaster />
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
